<div style="float: right;margin-right: 13px;margin-top: -1%;">
  <h6>Employee Last Update Date : {{LastUpdatedOn | date: "mediumDate":'GMT'}}
</h6></div>
<br>
<ng-container>
  <div class="container-tab overflow-xdir" [ngStyle]="{'height':vh +'px'}">
    <div class="card">
      <div class="card-body">
        <div class="card-holder">
          <h3 class="card-title">Total Mon GM (%) :&nbsp; </h3> <div class="card-title" [ngStyle]="{'color':totalMonGmSubMargin<=0||totalMonGmAddMargin<=0?'red':'#556479'}">{{ totalMonGM }}</div>
        </div>
        <div class="card-holder">
          <h3 class="card-title">Offshore (%) :&nbsp;</h3> <div class="card-title" [ngStyle]="{'color':totalOffGmSubMargin<=0||totalOffGmAddMargin<=0?'red':'#556479'}">{{ totalOffGM }}</div>
        </div>
        <div class="card-holder">
          <h3 class="card-title" >Onsite (%) :&nbsp; </h3> <div class="card-title" [ngStyle]="{'color':totalOnGmSubMargin<=0||totalOnGmAddMargin<=0?'red':'#556479'}">{{ totalOnGM }}</div>
        </div>
        <div >
          <button type="button" class="ct-btn" style="margin-right: 2%;" (click)="addFieldValue()">
            <span class="fa fa-plus-square-o span-btn"></span>
            Add row
          </button>
        </div>

         <div>
          <button type="button" class="ct-btn" style="margin-right: 8%;background-color: #e6eaee;" [disabled]="fetchMarginDisable" (click)="onMarginButtonClick()"> Fetch Margin </button>
        </div>
        <div>
          <a href="https://onlinect.sharepoint.com/:b:/r/sites/interct/Documents/Margin%20Calculator_User%20Guide.pdf?csf=1&web=1&e=7Go4Wt" target="_blank" rel="noopener noreferrer">
            <i class="ct-btn" type="button" class="fa fa-info-circle"
            title="Download User Guide" style="margin-top: -1.8%; float:right;font-size:18px;color:blue"></i>
          </a>

        </div>




        <div class="accord-content">
          <div class="table-responsive">
            <table class="table-default table-drive-view table-design">
              <thead>
                <tr>
                  <th style="width: 8%;">Location <span class="text-danger">*</span></th>
                  <th style="width: 15%">Emp Name/CT ID <span class="text-danger">*</span></th>
                  <th style="width: 9%">Emp Type <span class="text-danger">*</span></th>
                  <th style="width: 13%">Primary Skill (S) <span class="text-danger">*</span></th>
                  <th style="width: 12%"> Designation <span class="text-danger">*</span> </th>
                  <th style="width: 9%"> BR ($/hr) <span class="text-danger">*</span> </th>
                  <th style="width: 12%"> Allocation (%) <span class="text-danger">*</span></th>
                  <th style="width: 9%">Mon GM (%) <span class="text-danger">*</span></th>
                  <th style="width: -2%"> Cover in Margin </th>
                  <th style="width: -2%">  </th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let item of tableCollection">
                  <tr>
                    <td>
                      <select [(ngModel)]="item.selectedLocation" name="Location" (change)="gridEmpNameEditFilter(item)">
                        <option *ngFor="let loc of location" [selected]="loc == item.selectedLocation"
                          [value]="loc.Location">
                          {{ loc.Location }}
                        </option>
                      </select>
                    </td>
                    <td>
                      <app-dropdown #EmployeeDropdown class="dropdown-btn" [isPopover]="true" (itemChange)="onEditChange($event,item)"
                      [list]="item.EmployeeList" [showSearch]="true"
                                    [isSingleSelect]="true"
                                    [placeholder]="Select(item)?'Select':item.EMPName+'|'+item.CTEmployeeID">
                                </app-dropdown>
                      <!-- <select class="dropdown-btn" [(ngModel)]="item.EMPName" name="EmpName" (change)="onEditChange($event.target.value)">
                        <option *ngFor="let loc of item.GridData" [value]="loc.EMPName">
                          {{ loc.EMPName}} <br>  |  <br>{{loc.CTEmployeeID}}
                        </option>
                      </select> -->
                    </td>
                    <td>
                      <select class="dropdown-bt" [(ngModel)]="item.employType" name="EmpType" style="min-width:100% ;" (change)="ChangeEmpType()">
                        <option *ngFor="let loc of item.EmmployeeTypeList" [selected]="loc == item.employType"
                          [value]="loc.Emp_TypeAbbr">
                          {{ loc.Emp_TypeAbbr }}
                        </option>
                      </select>
                    </td>
                    <td>
                      <div>{{ item.primarySkill }}</div>
                    </td>
                    <td>
                      <div>{{ item.designation }}</div>
                    </td>
                    <td><input type="number" [(ngModel)]="item.BillingRate" name="BR" style="max-width:50% ;"
                        (change)=bRValidatorEdit($event.target.value,item) /></td>
                    <td><input type="number" [(ngModel)]="item.allocationPercentage" name="AP" style="max-width:30% ;"
                        (change)=allocationPercentageEditValidator($event.target.value,item) /></td>
                    <td>
                      <div type="text" [ngStyle]="{'color':item.monGMSubMargin<=0||item.monGMAddMargin<=0?'red':'#556479'}">{{item.monGM}}</div>
                    </td>
                    <td>
                      <input type="checkbox" [(ngModel)]="item.coverInMargin" name="CoverInMargin" (change)=ChangeCoverInMargin() />
                      <span class="checkmark"></span>
                    </td>
                    <td>
                      <i class="btn-delete"  (click)="confirmDialog(item)"
                        class="fa fa-trash-o"></i>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="rev-flex">
      <button type="button" class="ct-save-btn secondary-btn primary-color" (click)="CancelGridNames()" [hidden]="storeService.gridId==0">
        Cancel
      </button>
      <button type="button" class="ct-save-btn primary-btn primary-color" (click)="SaveAsMargCalc('saveAs')" [hidden]="!showSaveButton">
        Save As
      </button>
      <button type="button" class="ct-save-btn primary-btn primary-color" (click)="SaveAsMargCalc('save')" [hidden]="!showSaveButton || storeService.gridId==0">
        Save
      </button>
      <button type="button" class="ct-save-btn primary-btn primary-color" (click)="OpenGridNames()" [hidden]="!showOpen">
        Open
      </button>
  </div>
</ng-container>
<ng-container *ngIf="loading">
  <div class="spinner-holder" style="z-index: 999;">
    <div class="spinner spinner-border text-primary"></div>
  </div>
</ng-container>